import React from "react";
import PropTypes from "prop-types";

import { Icon } from "semantic-ui-react";

import Money from "components/Money";

export function DiscountField({ coupon, currency, onRemove }) {
  return (
    <div
      style={{ display: "flex", flexDirection: "column" }}
      data-test="discount-field"
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          rowGap: "20px",
          marginTop: "20px",
        }}
      >
        <b>Discount</b>
        <b style={{ justifySelf: "end" }}>
          -<Money currency={currency}>{coupon.discountAmount}</Money>
        </b>
      </div>

      <div style={{ display: "flex", gap: "10px", alignItems: "baseline" }}>
        <span>{coupon.name}</span>
        {onRemove && (
          <Icon
            name="close"
            onClick={onRemove}
            color="grey"
            style={{ cursor: "pointer" }}
            data-test="remove-coupon-button"
          />
        )}
      </div>

      {coupon?.discountDetails && (
        <span
          data-test="discount-details"
          style={{ color: "#595959", fontStyle: "italic", width: "80%" }}
        >
          {coupon.discountDetails}
        </span>
      )}
    </div>
  );
}

DiscountField.propTypes = {
  coupon: PropTypes.shape({
    name: PropTypes.string.isRequired,
    discountAmount: PropTypes.string.isRequired,
    discountDetails: PropTypes.string,
  }).isRequired,
  currency: PropTypes.string.isRequired,
  onRemove: PropTypes.func,
};

DiscountField.defaultProps = { onRemove: undefined };

export default DiscountField;
